<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/support"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">Account Deletion</ion-title>
      </ion-toolbar>
    </ion-header>
    <!--content start -->
    <ion-content>
      <ion-row>
        <ion-col>
          <p class="support-p">
            We're sorry to see you go! Deleting your account is a permanent
            action that will remove all your data from our system.
          </p>
          <p class="support-p">Before you proceed, please note:</p>
          <ul class="support-p margin-list">
            <li>
              All your data will be permanently deleted and cannot be recovered.
            </li>
            <li>
              You will lose access to all your saved preferences and purchase
              history.
            </li>
            <li>This action is irreversible.</li>
          </ul>
          <p class="support-p">
            If you are certain you want to delete your account, please follow
            the link below to complete the process:
          </p>
          <p class="support-p">
            <a href="https://onecoffeeapp.com.au/account-removal"
              >Delete My Account</a
            >
          </p>
          <p class="support-p">Thank you for being a part of our community.</p>
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <!-- content end -->
    </ion-content>
  </ion-page>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.margin-list {
  margin-left: 20px;
}

.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-p {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #666666;
  padding-left: 5%;
  padding-right: 5%;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from "@ionic/vue";

export default defineComponent({
  name: "AccountDeletion",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
  },
});
</script>
